module.exports = __webpack_public_path__ + "img/block5.4a192dda.svg";